import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import CancelButtonLink from '../../../common/buttons/cancelButtonLink';
import { STEPS } from '../constants';
import { t } from '../../../../modules/infra/i18n';

const Actions = ({ invalid, baseUrl, handleDelete, isDeletable, step, setStep, isAssignmentPageAvailable }) => {
  const SubmitOrBackButton = step === STEPS.details ? (
    <button
      type="submit"
      className="c-btn c-btn--medium u-width-120"
      disabled={invalid}
      form="serviceDetails"
    >
      <span className="c-btn__text">{isAssignmentPageAvailable ? t('services:form.actions.next') : t('services:form.actions.save')}</span>
    </button>
  ) : (
    <button
      type="button"
      className="c-btn c-btn--medium u-width-120 u-mr-"
      onClick={(e) => {
        e.preventDefault();
        setStep(STEPS.details);
      }}
    >
      <span className="c-btn__text">{t('services:form.actions.back')}</span>
    </button>
  );

  const deleteButton = isDeletable ? (
    <button
      type="button"
      className="c-btn c-btn--medium c-btn--red u-width-120 u-mr- u-float-left"
      onClick={handleDelete}
    >
      <span className="c-btn__text">{t('services:form.actions.delete')}</span>
    </button>
  ) : null;

  const cancelButton = (
    <CancelButtonLink
      className={cx('c-btn--medium', step === STEPS.details ? 'u-mr-' : 'u-mr0')}
      link={baseUrl}
      content={step === STEPS.details ? t('services:form.actions.cancel') : t('services:form.actions.save')}
    />
  );

  return (
    <div className="u-height-full o-flexbox o-flexbox--content-align-center u-pr">
      {deleteButton}
      {step === STEPS.details ? cancelButton : null}
      {SubmitOrBackButton}
      {step === STEPS.assignments ? cancelButton : null}
    </div>
  );
};

Actions.propTypes = {
  invalid: PropTypes.bool,
  baseUrl: PropTypes.string.isRequired,
  step: PropTypes.string.isRequired,
  setStep: PropTypes.func.isRequired,
  handleDelete: PropTypes.func,
  isDeletable: PropTypes.bool,
  isAssignmentPageAvailable: PropTypes.bool,
};

Actions.defaultProps = {
  pristine: true,
  invalid: false,
  handleDelete: null,
  isDeletable: false,
  isAssignmentPageAvailable: false,
};
export default Actions;
